<template>
  <div class="notation-stars">
    <div
      v-for="i in max"
      :key="i"
      class="star-container"
    >
      <icon-star-empty class="star-empty" />
      <div class="star-fill-wrapper" :style="{ width: getStarFillPercent(i) + '%' }">
        <icon-star-full class="star-full" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    notation: {
      required: true,
      type: Number
    },
    max: {
      required: false,
      type: Number,
      default: 5
    }
  },
  methods: {
    getStarFillPercent (starIndex) {
      // starIndex va de 1 à max
      // Si la note est 4.5, les étoiles 1-4 sont à 100%, l'étoile 5 est à 50%
      const starValue = starIndex
      if (this.notation >= starValue) {
        return 100
      } else if (this.notation > starValue - 1) {
        // Étoile partiellement remplie
        return (this.notation - (starValue - 1)) * 100
      }
      return 0
    }
  }
}
</script>

<style scoped>
.notation-stars {
  display: inline-flex;
  gap: 2px;
}
.star-container {
  position: relative;
  width: 14px;
  height: 14px;
}
.star-empty,
.star-full {
  width: 14px;
  height: 14px;
}
.star-empty {
  display: block;
}
.star-fill-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  height: 100%;
}
.star-full {
  display: block;
}
</style>
